<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()

const { foundDefects } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <div
    v-if="foundDefects.display"
    class="found-defects col-span-12"
    :class="{
      'lg:col-span-6': foundDefects.amountOfDefects < 15,
    }"
  >
    <SectionsDetailsElementsSection>
      <template #heading>
        {{ foundDefects.title }}
      </template>

      <template #content>
        <SectionsDetailsElementsTable :table="details.foundDefects" />
      </template>
    </SectionsDetailsElementsSection>
  </div>
</template>

<style lang="scss">
.found-defects {
  td {
    &:first-child {
      font-weight: 600;
      color: var(--color-primary);
    }
  }
}
</style>
